import moment from 'moment';

export default function determineBMPStatus(bmp = null, reportState = null){

	if (bmp == null){
		return null;
	} else if (bmp.cas === null){
		return "Documentation";
	} else if (bmp.correctionDocumentation !== null && bmp.correctionDocumentation !== undefined && typeof bmp.correctionDocumentation === "object"){
		let {description, photos} = bmp.correctionDocumentation;
		let hasDescription, hasPhotos = false;

		if (description !== ""  && description !== null && description !== undefined){
			hasDescription = true;
		}

		if (photos !== undefined && photos !== null && photos.length > 0){
			hasPhotos = true;
		}

		if (hasPhotos || hasDescription){
			return "Complete"
		} else {

			if (reportState.date){
				let date = reportState.date.toString();
				let loggedStartDate = moment(date).startOf("date");
				let today = moment().startOf("date");

				if (loggedStartDate.isBefore(today)){
					return "Overdue"
				} else {
					return "Incomplete"
				}
			}
		}

	} else {
		return null;
	}

}